export default __webpack_public_path__ + "static/media/ai-prescription-pill.ad62cd61.svg";